//staging
// export const media_url = "https://suraapistage.appgrowthcompany.com/";
// export const API_URL = "https://suraapistage.appgrowthcompany.com/";
// export const SOCKET_URL = "wss://suraapistage.appgrowthcompany.com";

//dev
export const API_URL = "https://api.sura-trade.com/";
export const media_url = "https://api.sura-trade.com/media/upload/";
export const SOCKET_URL = "wss://api.sura-trade.com";

//live
// export const API_URL = "https://api.sura-trade.com/";
// export const media_url = "https://api.sura-trade.com/";
// export const SOCKET_URL = "wss://api.sura-trade.com";

export const END_POINTS = {
  login: "admin/admin-login/",
  mediaUpload: "media/upload/",
  get_user: "admin/get-admin-detail/",
  logout: "admin/logout/",
  forgotPassword: "admin/forgot-password/",
  verifyOtp: "admin/verify-admin-otp/",
  resetPassword: "admin/reset-password/",
  changePassword: "admin/change-password/",
  uploadFiles: "media/upload/",

  //user
  changeUserStatus: "admin/update-manage-user-status/",
  customerList: "admin/get-all-manage-user/",
  vendorList: "admin/get-all-manage-vendor/",
  deleteCustomer: "admin/delete-manage-user",
  deleteVendor: "admin/delete-manage-vendor",
  updateCustomerById: "admin/update-manage-user/",
  customerById: "admin/get-manage-user",
  vendorById: "admin/get-manage-vendor",
  customerByiD: "admin/get-manage-user",
  userApprovalStatus: "admin/update-manage-user-profile-status",
  vendorApprovalStatus: "admin/update-manage-vendor-status/",
  updateVendor: "admin/update-manage-vendor",
  updateUser: "admin/update-manage-user",
  getAllCount: "admin/get-user-count/",
  userCsv: "admin/csv-users/",
  VendorCsv: "admin/csv-Vendor/",
  documentStatus: "admin/user-document-status/",

  //category
  category: "admin/get-all-category/",
  addCategory: "admin/add-category/",
  categoryById: "admin/get-category-details-by-id/",
  updateCategory: "admin/update-category/",
  deleteCategory: "admin/delete-category/",
  addSubCategory: "admin/add-sub-category/",
  subCategory: "admin/get-all-sub-category/",
  subCategoryById: "admin/get-sub-category-details-by-id/",
  updateSubCategory: "admin/update-sub-category/",
  deleteSubCategory: "admin/delete-sub-category/",
  allCategory: "admin/get-all-category-without-pagination/",
  allSubcategoriesByCatId: "admin/get-sub-category-by-category-id/",

  //banner
  addDiscount: "admin/admin-add-discount/",
  discountById: "admin/admin-get-manage-discount/",
  allDiscount: "admin/admin-get-all-manage-discount/",
  updateDiscount: "admin/admin-update-details/",
  discountStatusUpdate: "vendor/update-manage-product-status/",
  deleteDiscount: "admin/admin-delete-manage-discount/",
  allVendor: "admin/vendor-listing/",

  //discount
  addCoupon: "admin/add-discount_coupon/",
  getAllCoupon: "admin/get-all-manage-discount_coupon/",
  updateCoupon: "admin/update-discount-details_coupon/",
  getCouponById: "admin/get-manage-discount_coupon/",
  deleteCoupon: "admin/delete-manage-discount_coupon/",

  //profile
  updateProfile: "admin/update-admin-profile/",
  getProfile: "getProfile",

  //cms
  addContact: "admin//add-contact-suport/",
  cmsContact: "admin/add-contact-suport/",
  cmsPrivacy: "admin/add-privacy-policy/",
  cmsTerms: "admin/add-terms-condition/",
  cmsAboutUs: "admin/add-about-us/",
  cmsDataDeletion: "admin/add-data-deletion/",
  getCms: "admin/get-cms-detail/",
  addPrivacy: "admin/add-privacy-policy/",
  termsCondition: "admin/add-terms-condition/",
  cookies: "admin/add-cookies/",
  dataDeletion: "admin/add-data-deletion/",
  addAgreement: "admin/add-agreement/",

  //dashboard
  dashboardData: "admin/get-dashboard-data/",
  userGraph: "admin/get-dashboard-user-graph-data/",
  orderGraph: "admin/get-dashboard-order-graph-data/",
  vendorGraph: "admin/get-dashboard-vendor-graph-data/",
  productGraph: "admin/get-dashboard-product-graph-data/",
  revenueGraph: "admin/get-dashboard-commission-graph-data/",
  myNotifications: "admin/get-admin-notification/",

  //products
  productsListing: "admin/get-all-product-listing/",
  updateProduct: "admin/update-product-details/",
  editProduct: "admin/update-product-details-by-id/",
  productById: "admin/get-manage-product/",
  bestProducts: "admin/best-product-update/",
  productCount: "admin/product-count/",
  addProduct: "admin/add-product/",
  productByVendor: "admin/vendor-product-listing/",

  //order
  allOrders: "admin/get-all-manage-order/",
  orderDetailById: "admin/get-manage-order/",
  orderStatus: "admin/update-manage-order-status/",
  refund: "admin/get-all-orders-for-refund-on-platform/",
  refundPayment: "admin/refund-payment-to-user/",
  orderCsv: "admin/order-csv/",
  oderByiD: "admin/get-manage-order/",
  orderCount: "admin/order-count/",

  //notifications
  allNotifications: "admin/all-notifications/",
  addNotification: "admin/add/notification/",
  deleteNotification: "admin/delete-notification/",

  //chat
  chatList: "admin/vendor-chat/sessions/",
  chatHistory: "admin/chat-history-by-session/",

  //payment
  paymentSummary: "admin/payment-to-vendor-summary/",
  paymentToVendor: "admin/payment-to-vendor/",

  //quote
  getAllQuotes: "admin/vendor-quotes/",
  revertQuote: "admin/vendor-quotes-revert/",
  quoteCount: "admin/quote-count",

  //return and exchange
  returnExchangeListings: "admin/get-all-manage-return-exchaneg-order/",
  exchangeById: "admin/get-return-exchange-manage-order/",
  deletById: "admin/delete-return-exchange-manage-order/",
  orderStatusUpdate: "admin/update-return-exchange-manage-order-status/",
  exchangeAcceptReject: "admin/admin-exchange-request-acc-rej/",
  returnAcceptReject: "admin/admin-return-request-acc-rej/",

  //subadmin
  allSubAdmin: "admin/get-all-subadmin/",
  subadminById: "admin/get-subadmin-by-id",
  addSubAdmin: "admin/add-sub-admin/",
  deleteSubAdmin: "admin/delete-subadmin/",
  updateSubAdmin: "admin/update-subadmin/",
  updateSubAdminStatus: "admin/update-subadmin-status-by-id/",
  allSubRole: "admin/get-all-sub-role/",
  addSubRole: "admin/add-sub-role/",
  deleteSubRole: "admin/delete-sub-role",

  //customer support
  allQuery: "admin/admin-query-listing/",
  queryById: "admin/admin-query-revert/",

  //settings
  generelSettings: "admin/general-settings/",
  allSettings: "admin/get-all-general-settings/",
  settingsById: "admin/get-by-id-general-settings/",
  updateSettings: "admin/update-general-settings/",
  addTime: "admin/add-time-cms/",
  addService: "admin/add-service-fee/",
  adminCms: "vendor/admin-cms/",
  getConversionRate: "admin/get-conversion-rate/",
  setConversionRate: "admin/set-conversion-rate/",
};
